import { render } from "./bttc.vue?vue&type=template&id=514751a0"
import script from "./bttc.vue?vue&type=script&lang=js"
export * from "./bttc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__